module.exports = __webpack_public_path__ + "static/media/cp84.7197946c.jpg";